'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import getMediaBlob, { type GetMediaBlobParams } from '.';
import { get_media_blob_query_key } from './query-key';
export default function useGetMediaBlob(t0) {
  const $ = _c(8);
  const {
    media_id
  } = t0;
  let t1;
  if ($[0] !== media_id) {
    t1 = get_media_blob_query_key({
      media_id
    });
    $[0] = media_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== media_id) {
    t2 = async () => await getMediaBlob({
      media_id
    });
    $[2] = media_id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !!media_id;
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return useQuery(t4);
}